import { addToaster, WorkflowInstanceTaskType } from '@app-store'
import { MutableRefObject } from 'react'
import { v4 as uuid } from 'uuid'
import { AppDispatch } from './agent.store'
import { NAMESPACES } from './constants'

export const dispatchDemographicUpdateToasterFromTaskList = (
  dispatch: AppDispatch,
  taskList: WorkflowInstanceTaskType[] | undefined,
  hasShownRef: MutableRefObject<boolean>
) => {
  if (!taskList?.length || hasShownRef.current) {
    return
  }

  const lastTask = taskList[taskList.length - 1]
  const hasAddressUpdate = lastTask?.identifier?.addressUpdated === true
  const hasPhoneUpdate = lastTask?.identifier?.phoneNumberUpdated === true

  if (!hasAddressUpdate && !hasPhoneUpdate) {
    return
  }

  const message =
    hasAddressUpdate && hasPhoneUpdate
      ? NAMESPACES.ADDRESS_AND_PHONE_UPDATED
      : hasAddressUpdate
      ? NAMESPACES.ADDRESS_UPDATED
      : NAMESPACES.PHONE_NUMBER_UPDATED

  dispatch(
    addToaster({
      id: uuid(),
      message,
      type: 'info',
      duration: 'slow',
    })
  )
  hasShownRef.current = true
}
